module.exports = require('gatsby-image');
